export const isEmpty = (val: string | null | undefined) => {
  return val === undefined || val == null || val.length <= 0 ? true : false
}
